import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import './blink_me.css';

import Firebase from 'firebase'
import ReactFireMixin from 'reactfire'
import reactMixin from 'react-mixin'
import "whatwg-fetch"

// import { Base64Binary } from "./base64-binary"

import { Nav, Navbar, NavItem } from 'react-bootstrap';
// import { Button, Nav, Navbar, NavItem } from 'react-bootstrap';

// import Plotly from 'plotly.js'

/* global Plotly */

const centerStyle ={
  textAlign: "center",
};

class SimpleLabel extends Component {

  make_label12(label, value, unit, context) {
    var class_context = "panel panel-" + context;

    var footerStyle = {padding: "5px 5px"};
    var panelStyle = {marginBottom: "15px"};

    return (
      <div className="col-lg-12 col-md-12">
        <div className={class_context} style={panelStyle}>
          <div className="panel-heading">
            <div className="row">
              <div className="col-lg-6 col-md-12 text-left">
                <div className="large">
                  {label}
                </div>
              </div>
              <div className="col-lg-6 col-md-12 text-right">
                <div className="large">
                  {value + " " + unit}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );

  }

  render() {
    var self = this;
    return self.make_label12(self.props.label, self.props.value, "", "warning");
  }
}



class CurrenttimeLabel extends SimpleLabel {

  zeropad(num, size) {
    var s = "000000000" + num;
    return s.substr(s.length-size);
  }

  render() {
      var _this = this;

      var now = new Date(); 

      var fmt = "YEAR-MONTH-DAY HOUR:MINUTE:SECONDS"
      var msg= fmt.replace("YEAR", now.getUTCFullYear())
	  .replace("MONTH", this.zeropad(now.getUTCMonth()+1, 2))
	  .replace("DAY", this.zeropad(now.getUTCDate(), 2))
	  .replace("HOUR", this.zeropad(now.getUTCHours(), 2))
	  .replace("MINUTE", this.zeropad(now.getUTCMinutes(), 2))
	  .replace("SECONDS", this.zeropad(now.getUTCSeconds(), 2))

      return this.make_label12("Current Time", msg, "", "info");
  }
}


class DatetimeLabel extends SimpleLabel {

  get_time_diff( datetime ) {
    datetime = typeof datetime !== 'undefined' ? datetime : "2014-01-01 01:02:03.123456";

    datetime = new Date( datetime ) //.getTime();

    var now = new Date(); 
    var now_utc = now;


    if( isNaN(datetime) )
    {
        return "";
    }

    // console.log( datetime + " " + now + " " + now_utc);
    var milisec_diff = 0;

    if (datetime < now_utc) {
        milisec_diff = now_utc - datetime;
    } else {
        milisec_diff = datetime - now_utc;
    }

    var days = Math.floor(milisec_diff / 1000 / 60 / (60 * 24));

    var date_diff = new Date( milisec_diff );

    return [days, date_diff.getUTCHours(), date_diff.getUTCMinutes()];
  }


  render() {
    var self = this;

    var dt = self.props.value;
    var msg = "";

    // console.log("123" + dt)
    var day_hour_min = self.get_time_diff( dt );

    // console.log(day_hour_min)

    var context = "danger"

    if (day_hour_min[0] > 0) {
      msg = "Last update older than " + day_hour_min[0] + " days";
    } else if (day_hour_min[1] > 0) {
      msg = "Last update older than " + day_hour_min[1] + " hours";
    } else if (day_hour_min[2] > 2) {
      msg = "Last update older than " + day_hour_min[2] + " minutes";
    } else {
      msg = "Last update within a minute.";
      context = "warning"
    };

    return self.make_label12(msg, self.props.label, "", context);
  }
}



class LabelSix extends Component {

  convert_value(value) {
    return value;
  }

  get_unit() {return "";}
  get_context() {return "";}
  get_labelStyle(state) {return {};}

  make_label (klabel, hkInfo, label, value) {
    var label_state = "normal";

    if (label) {
    } else {
        // console.log(klabel, hkInfo["current_readings"][klabel]);
	value = hkInfo["current_readings"][klabel];
	var info = hkInfo["temp_info"][klabel];
	label = info["label"];
	var value_normal = info["normal"];
        label = `${label} (${value_normal} K)`

        if (value == -999) {
            label_state = "unknown";
        }
	      else if ((value > info["upper"]) | (value < info["lower"])) {
	          label_state = "error";
	      }
    }

    if (value == null) {
      value = "undefined";
    } else {
       value = this.convert_value(value);
    }

    var context = this.get_context(label_state);
    var class_context = "panel panel-" + context;
    var unit = this.get_unit();

    // console.log(context);

    var panelStyle = {marginBottom: "15px"};
    var footerStyle = {padding: "5px 5px"};
    var labelStyle = this.get_labelStyle(label_state);


    return (
      <div className="col-lg-6 col-md-12">
        <div className={class_context} style={panelStyle}>
          <div className="panel-heading">
            <div className="row">
              <div className="col-lg-8 col-md-12 text-left">
                <div className="large">
                  {label}
                </div>
              </div>
              <div className="col-lg-4 col-md-12 text-right">
                <div className="large" style={labelStyle}>
                  {value + " " + unit}
                </div>
              </div>
            </div>
          </div>
          <div className="panel-footer" style={footerStyle}>
            <div className="clearfix"/>
          </div>
        </div>
      </div>
    );

  }

  render() {
    return this.make_label(this.props.klabel, this.props.hkInfo,
			   this.props.label, this.props.value);
  }
}


class LabelSix48 extends LabelSix {

  make_label (klabel, hkInfo, label, value) {
    var label_state = "normal";

    if (label) {
    } else {
        // console.log(klabel, hkInfo["current_readings"][klabel]);
	value = hkInfo["current_readings"][klabel];
	var info = hkInfo["temp_info"][klabel];
	label = info["label"];
	var value_normal = info["normal"];
        label = `${label} (${value_normal} K)`

        if (value == -999) {
            label_state = "unknown";
        }
	      else if ((value > info["upper"]) | (value < info["lower"])) {
	          label_state = "error";
	      }
    }

    if (value == null) {
      value = "undefined";
    } else {
       value = this.convert_value(value);
    }

    var context = this.get_context(label_state);
    var class_context = "panel panel-" + context;
    var unit = this.get_unit();

    // console.log(context);

    var panelStyle = {marginBottom: "15px"};
    var footerStyle = {padding: "5px 5px"};
    var labelStyle = this.get_labelStyle(label_state);


    return (
      <div className="col-lg-6 col-md-12">
        <div className={class_context} style={panelStyle}>
          <div className="panel-heading">
            <div className="row">
              <div className="col-lg-4 col-md-12 text-left">
                <div className="large">
                  {label}
                </div>
              </div>
              <div className="col-lg-8 col-md-12 text-right">
                <div className="large" style={labelStyle}>
                  {value + " " + unit}
                </div>
              </div>
            </div>
          </div>
          <div className="panel-footer" style={footerStyle}>
            <div className="clearfix"/>
          </div>
        </div>
      </div>
    );

  }

}


class TempLabel extends LabelSix {

  convert_value(value) {
    return value.toFixed(1);
  }

  get_unit() {return "K";}
  get_context(label_state) {
      if (label_state === "error") {
	  return "danger";
      }
      return "primary";
  }
  get_labelStyle(label_state) {
      if (label_state === "error") {
	  return {color: "red",
		  animation: "blinker 1s linear infinite"
		 };
      }
      return {color: "yellow"};
  }

}

class PercentLabel extends LabelSix {

  convert_value(value) {
    return value.toFixed(2);
  }

  get_unit() {return "%";}
  get_context() {return "primary";}

}


class PressureLabel extends LabelSix48 {

  convert_value(value) {
    return value.toExponential(2);
  }

  get_unit() {return "Torr";}
  get_context() {return "success";}

  make_label (klabel, hkInfo, label, value) {
    var label_state = "normal";

    if (label) {
    } else {
        // console.log(klabel, hkInfo["current_readings"][klabel]);
	value = hkInfo["current_readings"][klabel];
	var info = hkInfo["temp_info"][klabel];
	label = info["label"];
	var value_normal = info["normal"];
        label = `${label} (${value_normal} K)`

        if (value == -999) {
            label_state = "unknown";
        }
	      else if ((value > info["upper"]) | (value < info["lower"])) {
	          label_state = "error";
	      }
    }

    if (value == null) {
      value = "undefined";
    } else {
       value = this.convert_value(value);
    }

    var context = this.get_context(label_state);
    var class_context = "panel panel-" + context;
    var unit = this.get_unit();

    // console.log(context);

    var panelStyle = {marginBottom: "15px"};
    var footerStyle = {padding: "5px 5px"};
    var labelStyle = this.get_labelStyle(label_state);


    return (
      <div className="col-lg-6 col-md-12">
        <div className={class_context} style={panelStyle}>
          <div className="panel-heading">
            <div className="row">
              <div className="col-lg-6 col-md-12 text-left">
                <div className="large">
                  {label}
                </div>
              </div>
              <div className="col-lg-6 col-md-12 text-right">
                <div className="large" style={labelStyle}>
                  {value + " " + unit}
                </div>
              </div>
            </div>
          </div>
          <div className="panel-footer" style={footerStyle}>
            <div className="clearfix"/>
          </div>
        </div>
      </div>
    );

  }
}


// var b64_to_array_old = function(encoded, array_type, convert) {
//     //var encoded = json["base64_dict"]["coldhead02"];
//     var buf = new Buffer.from(encoded || '', 'base64') // .toString('utf8')

//     var view = new Uint8Array(buf.length);
//     for (var i = 0; i < buf.length; ++i) {
// 	view[i] = buf[i];
//     }

//     var byteArray = new array_type(buf.buffer);

//     var r = [];
//     if (convert) {
// 	var floatArray = new Float32Array(byteArray.length);
// 	for (var i = 0; i < byteArray.length; ++i) {
// 	    floatArray[i] = convert(byteArray[i]);
// 	}
// 	return floatArray;
//     } else {
// 	return byteArray;
//     }

// }

var b64_to_array = function(encoded, array_type, convert) {
    //var encoded = json["base64_dict"]["coldhead02"];
    var buf = new Buffer.from(encoded || '', 'base64') // .toString('utf8')

    var view = new Uint8Array(buf.length);
    for (var i = 0; i < buf.length; ++i) {
	view[i] = buf[i];
    }

    var byteArray = new array_type(buf.buffer);

    var r = [];
    if (convert) {
	for (var i = 0; i < byteArray.length; ++i) {
	    r.push(convert(byteArray[i]));
	}
	return r;
    } else {
	for (var i = 0; i < byteArray.length; ++i) {
	    r.push(byteArray[i]);
	}
	return r;
    }

}

const hk_temp_names = ["coldhead02",
                       "coldhead01",
                       "bench", 
                       "detH", "detK",
                       "detS", "grating",
		       "rack_computer", "rack_air"
                      ]

const hk_temp_info = {"coldhead01":{label:"ColdHead#1",
				                            normal:62, lower:56, upper:75},
                      "coldhead02":{label:"ColdHead#2",
				                            normal:16, lower:15, upper:17},
		                  "bench":{label:"Bench",
			                         normal:120, lower:115, upper:128}, 
		                  "detH":{label:"Det H",
			                        normal:65, lower:64, upper:66},
		                  "detK":{label:"Det K",
			                        normal:66, lower:65, upper:67},
		                  "detS":{label:"Det S",
			                        normal:60, lower:55, upper:70},
		                  "grating":{label:"Grating",
				                         normal:130, lower:129, upper:131},
		                  "rack_computer":{label:"Rack Comp.",
				                               normal:"~280", lower:270, upper:300}, 
		                  "rack_air":{label:"Rack Air",
				                          normal:"~280", lower:270, upper:300}
			               }


var plotly_show_message = function(divid, msg) {

    var layout = {annotations: [
        {
	    text: msg,
	    x: 0.5, xref: 'paper',
	    y: 0.5, yref: 'paper',
	    showarrow: false
	}
    ]};

    Plotly.newPlot(divid, [], layout);

}

class App extends Component {

  state = {
	items: [],
        items_ready:false,
	item_now: [],
        item_now_ready:false,
	current_time : null,
	last_update : new Date(),
        load_percentage : "",
        page_status : "table"
  }

  plot_validate = true;

  history_dict = {};


  page_changed_cb(new_page_status) {
      if (this.state.page_status === new_page_status) {
	  // do nothing
      } else {
	  self.graphDiv = null;
	  self.graphHistoryDiv = null;
      }
  }

  getNavbarInstance() {
    var disabled = false;

    var self = this;

    var onSelect = function(eventKey) {
      self.page_changed_cb(eventKey);
      self.setState({page_status : eventKey});
      // console.log(eventKey);
    }

    return (
      <Navbar onSelect={onSelect}>
        <Navbar.Header>
          <Navbar.Brand>
            IGRINS Watchdog
          </Navbar.Brand>
        </Navbar.Header>
        <Nav activeKey={this.state.page_status}>
          <NavItem eventKey="table" disabled={disabled} href="#">Table</NavItem>
          <NavItem eventKey="plot" disabled={disabled} href="#">Plot</NavItem>
          <NavItem eventKey="history" disabled={disabled} href="#">History</NavItem>
        </Nav>
      </Navbar>
    );
  }

  check_if_need_update(thresh_milisec) {
    var self = this;
    var datetime = new Date();
    // var datetime = typeof datetime !== 'undefined' ? datetime : "2014-01-01 01:02:03.123456";

    var milisec_diff = datetime - self.state.last_update;
    // console.log( this.state.last_update, datetime, milisec_diff );

    
    if (milisec_diff > thresh_milisec) {
	console.log("length", self.state.items.length, (self.num_points - 2));
	return 1;
    } else {
	return 0;
    }

  }

  update_time() {
      var self = this;
      var datetime = new Date();
      self.state.last_update = datetime;
  }

  componentWillMount() {
    var self = this;
    console.log("mount event");
    self.firebaseRef = new Firebase('https://igrins-hk.firebaseio.com/BasicHK');
    self.num_points = 4000;

    
    // console.log("binding 1");
    var _q = self.firebaseRef.orderByChild('utc_upload').limitToLast(1)

    _q.on("child_added", function(snap) {
                        self.setState({item_now: [snap.val()],
				       item_now_ready: true
				      });
                      });



    // this.bindAsArray(_q, 'item_now');

    var _q2 = self.firebaseRef.orderByChild('utc_upload').limitToLast(self.num_points);

    _q2.once("value", function() {
                        console.log("done once");
                        self.setState({items_ready: true});
                       });
    // this.bindAsArray(_q2, 'items');

    this.items = [];

    this._loaded_percent = 0;

    _q2.on("child_added", function(snap) {

      this.items.push(snap.val());
      this.plot_validate = false;

      while (this.items.length > self.num_points) {
        console.log("removing");
        this.items.shift();
      }

      this._loaded_percent = Math.ceil(5 * this.items.length / this.num_points);

    }.bind(this));

  }

  componentWillUnmount() {
    self.firebaseRef.off();
    clearInterval(this.timer_clock);
    clearInterval(this.timer_plot);
  }

  getMyPlotData() {
      var datetimes = this.get_datetimes(this.items, "datetime");

      var y_names = hk_temp_names;
// ["coldhead02",
//                      "bench", 
//                      "detH", "detK",
//                      "detS", "grating",
// 		     "rack_computer", "rack_air"
//                     ]

      var all_list = this.get_list(this.items, y_names);

      var y2_names = ["pressure"];
       
      var all2_list = this.get_list(this.items, y2_names);

      var _d = this.getPlotData(datetimes, all_list, all2_list);
      
      return _d;
  }
      
  tick_plot(self) {

    if (self.state.page_status === "plot") {

      if (self.items.length > 0) {

          var graphDiv = document.getElementById('graphDiv');
          if (graphDiv) {
            if (!self.graphDiv) {

              console.log("drawing new plot", graphDiv);
       
              var _d = self.getMyPlotData();
       
              Plotly.newPlot(graphDiv, _d[0], _d[1], _d[2]);
              self.plot_validate = true;
              self.graphDiv = graphDiv;

            }
          } else {
            self.graphDiv = null;
          }

	  if (self.plot_validate) {
	      console.log("skip");
	  } else {
	      console.log("tick : redraw plot");
	      // self.update_plot_if_required();
	      self.doPlot_orig();
	      // console.log(self.update_plot_if_required);
	  };	  
      };

    } else {
      self.graphDiv = null;
    }

  }

  tick_clock(self){

        self.setState({current_time: new Date()});

  }

  componentDidMount() {
      var self = this;

      var _tick_plot = function() {self.tick_plot(self);};
      var _tick_clock = function() {self.tick_clock(self);};


      self.timer_plot = setInterval(_tick_plot, 200);
      self.timer_clock = setInterval(_tick_clock, 100);

      // console.log(self.state.items);

      console.log("waiting for db connection");


  }

  getPlotData(datetimes, all_list, all_list2) {
    var _d1 = [];
    if (typeof all_list !== 'undefined') {
	for (var v of all_list) {
	    // v : (key, list)
	    
            var _v = { x: datetimes,
		       y: v[1],
		       name : v[0],
		       type: 'scatter'
		     };
	    _d1.push(_v);
	}
    } else {
	// console.log("NoNoNo");
	_d1.push({ x: [],
		   y: [],
		   type: 'scatter'
		 });
    }

    // now for all_list2
    if (typeof all_list2 !== 'undefined') {
	for (var v of all_list2) {
	    // v : (key, list)
	    
            var _v = { x: datetimes,
		       y: v[1],
		       name : v[0],
		       yaxis: 'y2',
		       type: 'scatter',
		       visible: 'legendonly'
		     };
	    _d1.push(_v);
	}
    } else {
	// console.log("NoNoNo");
	_d1.push({ x: [],
		   y: [],
		   type: 'scatter'
		 });
    }

    var _d2 = { margin: {t: 40, r: 40, l: 100},
		// hovermode: !1,
		// title: "IGRINS Temperatures",
		xaxis: {gridcolor: 'transparent',
			// tickmode: "auto",
			// nticks: 10,
			// showticklabels: false
			title: 'Time (UT)',
			domain: [0., 0.9]

			},

		yaxis: {
		    // rangemode : "tozero",
		},

		yaxis2: {
		    title: 'Pressure',
		    titlefont: {color: 'rgb(148, 103, 189)'},
		    tickfont: {color: 'rgb(148, 103, 189)'},
		    overlaying: 'y',
		    side: 'right',
		    // rangemode : "tozero",
                    type: "log"
		}


	      };
    var _d3 =  { displayModeBar: true
	       };

    return [_d1, _d2, _d3];
  }

  doPlot_orig () {
      console.log("drawing plot");
      var self = this;

      var _d = self.getMyPlotData();
       
      self.graphDiv.data = _d[0];
      // Plotly.newPlot('plot', _d[0], _d[1], _d[2]);
      Plotly.redraw(self.graphDiv);
      this.plot_validate = true;
  }

  doPlot () {
  }


  plot_history(json_name) {
      var history = this.history_dict[json_name];

      var _d2 = { margin: {t: 40, r: 40, l: 100},
		  xaxis: {gridcolor: 'transparent',
			  title: 'Time (UT)',
			 },

		  yaxis: {
		  },
		};
      var _d3 =  { displayModeBar: true
		 };


      if (history) {
	  console.log('start new plot, with cached data');
          plotly_show_message("graphHistoryDiv", "ploting data (may take a few seconds)");
	  var _f = function() {
	      Plotly.newPlot("graphHistoryDiv",
			     history, _d2, _d3);
	  }

	  setTimeout(_f, 10); // plotting directly seems to block rendering. sp, we put some small time dealy.

      } else {
	  var plot_func = function(data_list) {
	      console.log('start new plot, with fetched data');
              plotly_show_message("graphHistoryDiv", "ploting data (may take a few seconds)");

	      var _f = function() {
		  Plotly.newPlot("graphHistoryDiv",
				 data_list, _d2, _d3);
	      }

	      setTimeout(_f, 10);
	      // Plotly.newPlot("graphHistoryDiv",
	      // 		     data_list, _d2, _d3);
	  };

          plotly_show_message("graphHistoryDiv", "Loading data (may take a while)");

	  this.fetch_history(json_name, plot_func);

      }


  }

  fetch_history(json_name, plot_func) {
      var self = this;
      fetch(json_name)
          .then(function(response) {
              return response.json();
          }).then(function(json) {
	      var data_list = self.convert_history(json);
	      plot_func(data_list);
	      self.history_dict[json_name] = data_list;
	      // self.plot_history(json);
          }).catch(function(ex) {
              console.log('parsing failed', ex);
          });
  }

  convert_history(json) {
      var datetime_start_min = json["datetime_start_min"];
      var min_to_date = function(_i) {
	  return new Date((datetime_start_min + _i) * 1000);
      }

      var encoded = json["base64_datetime_min"];
      var datetimeArray = b64_to_array(encoded,
				       Uint32Array, min_to_date);

      var bscale = json["bscale"];

      var zero_to_null = function(_i) {
	  if (_i > 0) {
	      return _i*bscale;
	  } else {
	      return null;
	  }
      }

      var tv = json["base64_dict"];
      var data_list = [];
      
      for (let temp_key of json["temp_key_list"]) {
	  var encoded = tv[temp_key];
	  var myArray = b64_to_array(encoded,
					 Uint16Array, zero_to_null);
	  
          data_list.push({ x:datetimeArray,
			   y:myArray,
			   name:temp_key,
			   type:"scatter"
			 });
      }
      return data_list;
  }

  history_init() {
    var self = this;
    if (self.state.page_status === "history") {

          var graphHistoryDiv = document.getElementById('graphHistoryDiv');
          if (graphHistoryDiv) {
            if (!self.graphHistoryDiv) {

              console.log("drawing new plot", graphHistoryDiv);
       
              self.graphHistoryDiv = graphHistoryDiv;
	      // plotly_show_message("graphHistoryDiv", "loading data (may take a while)");

              // var json_name = '/hk_history_201609_201612.json';
              var json_name = '/hk_history_201609_201702.json';
	      // var json_name = "https://firebasestorage.googleapis.com/v0/b/igrins-hk.appspot.com/o/history%2Fhk_history_201609_201612.json?alt=media&token=96e4f7c4-be26-47a4-ad6a-10551505089a";



              this.plot_history(json_name, graphHistoryDiv);

            }
          } else {
            self.graphHistoryDiv = null;
          }



    } else {
      self.graphHistoryDiv = null;
    }

  }


  componentDidUpdate() {


    this.history_init();

    if (this.state.items.length > 0) {
      if (this.state.items.length === 1) {
          console.log("db connected");
      }

      this.plot_validate = false;
    }

  }

  get_datetimes(items, x) {

      var datetimes = [];

      for (var i of items) {
	  // This is a hack to disaply UTC in plotly.
	  // Plotly add timezone to convert it to a local time.

	  var t1 = new Date(i[x]);
          var t2 = new Date(Number(t1) + t1.getTimezoneOffset()*60*1000);
		      
	  datetimes.push(t2);
      }

      return datetimes;
  }

  get_list(items, kl) {

      var l = [];

      // for (var k of kl) {
      // 	  l[k] = [];
      // }

      for (var k of kl) {
	  var l1 = []
	  for (var i of items) {
	      if (i[k] > 0) {
		  l1.push(i[k]);
	      } else {
		  l1.push(null);
	      }		  
	  }
	  l.push([k, l1]);
      }

      return l;
  }

  render_plot() {

    var _k = (<div></div>);

    if (!this.state.items_ready) {
	_k = (
            <div>

              <div className="panel panel-warning">
                <div className="panel-heading">
                  <div className="row">
                    <div className="col-lg-6 col-md-12 text-left">
                      <div className="large">
                        Data is loading (may take a while)
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <img src={logo} className="App-logo" alt="logo" />
              <p> Waiting for data
              </p>
            </div>
	);
    }

    return (
      <div className="container-fluid">
        <div id="graphDiv">
            <div style={centerStyle}>
              {_k}
            </div>
        </div>
      </div>
    );
  }

  render_history() {

    var _k = (<div></div>);

    if (false) { // !this.state.items_ready) {
	_k = (
            <div>

              <div className="panel panel-warning">
                <div className="panel-heading">
                  <div className="row">
                    <div className="col-lg-6 col-md-12 text-left">
                      <div className="large">
                        Data is loading (may take a while)
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <img src={logo} className="App-logo" alt="logo" />
              <p> Waiting for data
              </p>
            </div>
	);
    }

    return (
      <div className="container-fluid">
        <div id="graphHistoryDiv">
            <div style={centerStyle}>
              {_k}
            </div>
        </div>
      </div>
    );
  }


  render_time(no_datetime) {

    var last_time = (
	    <div>
	    </div>
    );

    if (this.state.item_now.length > 0) {

	var cur_time = this.state.item_now[0]["date"] + " " + this.state.item_now[0]["time"];
	var datetime = this.state.item_now[0]["datetime"];

	if (!no_datetime) {
	    last_time = (
		    <DatetimeLabel label={cur_time} value={datetime}/>
	    );
	}
    }
	

    // var cur_time = "123";
    // var datetime = "456";

    return (
      <div className="container-fluid">
         <div className="row">
           <CurrenttimeLabel label="Current time :"/>
         </div>
         <div className="row">
           {last_time}
         </div>
      </div>
    );
  }

  render_table() {
    // var cur_time = this.state.item_now[0]["date"] + " " + this.state.item_now[0]["time"];
    // var datetime = this.state.item_now[0]["datetime"];

    if (!this.state.item_now_ready) {
	return  (
          <div className="container-fluid">
            <div className="row">
             <div style={centerStyle}>
              <img src={logo} className="App-logo" alt="logo" />
              <p> Waiting for data
              </p>
             </div>
            </div>
          </div>
	);
    }

    var v = this.state.item_now[0];
    var td = hk_temp_info;
    var hkInfo = {current_readings:this.state.item_now[0],
                  temp_info:hk_temp_info};
    return (
      <div className="container-fluid">
         <div className="row">
           <PressureLabel label="Pressure" value={v["pressure"]}/>
           <LabelSix48 label="Alert" value={v["alert_status"]}/>
         </div>
         <div className="row">
            <TempLabel klabel="coldhead01" hkInfo={hkInfo}/>
            <TempLabel klabel="coldhead02" hkInfo={hkInfo}/>
         </div>
         <div className="row">
           <TempLabel klabel="rack_computer" hkInfo={hkInfo}/>
            <TempLabel klabel="rack_air" hkInfo={hkInfo}/>
          </div>
         <div className="row">
           <TempLabel klabel="detH" hkInfo={hkInfo}/>
           <PercentLabel label="Det H - TC" value={v["detH_tc"]}/>
         </div>
         <div className="row">
           <TempLabel klabel="detK" hkInfo={hkInfo}/>
           <PercentLabel label="Det K - TC" value={v["detK_tc"]}/>
         </div>
         <div className="row">
           <TempLabel klabel="detS" hkInfo={hkInfo}/>
           <PercentLabel label="Det S - TC" value={v["detS_tc"]}/>
         </div>
         <div className="row">
           <TempLabel klabel="grating" hkInfo={hkInfo}/>
           <PercentLabel label="Grating - TC" value={v["grating_tc"]}/>
         </div>
         <div className="row">
           <TempLabel klabel="bench" hkInfo={hkInfo}/>
           <PercentLabel label="Bench TC" value={v["bench_tc"]}/>
         </div>
      </div>
    );
  }


  // render_ready() {
  //     // if (this.state.items.length > 0) {
  //     // 	  return <div></div>;
  //     // } else {
  // 	  return (
  // 	    <div className="container-fluid">
  // 	      <div className="row">
  // 	        <CurrenttimeLabel label="Current time :"/>
  //             </div>
  //             <div className="row">
  //               <SimpleLabel label="Waiting for DB connection" value=""/>

  //               <div style={centerStyle}>
  //                 <img src={logo} className="App-logo" alt="logo" />
  //               </div>

  //             </div>
  //           </div>
  // 	  );
  //     // };
  // }

  make_percent_label() {
    var self = this;
    var _p = Math.ceil(100 * self.state.items.length / self.num_points);

    return (
      <div>
        {_p}
      </div>
    );
  }

  handleSelect(eventKey) {
    event.preventDefault();
    // alert(`selected ${eventKey}`);
  }


  render() {
        // this.setState({current_time: new Date()});

      var navbarInstance = this.getNavbarInstance()

      // if (this.state.page_status === "ready") {
      // 	  return (
      //       <div className="container">
      //          {navbarInstance}
      //          {this.render_ready()}
      //       </div>
      //     )
      // } else 
      if (this.state.page_status === "table") {
	  // return [this.make_percent_label(), this.render_ready()];
	  // return this.render_ready();
	  return (
            <div className="container">
               {navbarInstance}
               {this.render_time()}
               {this.render_table()}
            </div>
          )
      } else if (this.state.page_status === "plot") {
	  // return [this.make_percent_label(), this.render_ready()];
	  // return this.render_ready();
          //     {this.render_time()}
          //  className="container"
	  return (
            <div>
              <div className="container">
               {navbarInstance}
               {this.render_time()}
               {this.render_plot()}
              </div>
            </div>
          )
      } else if (this.state.page_status === "history") {
	   // do not show "datatime" label
	  return (
            <div>
              <div className="container">
               {navbarInstance}
               {this.render_time(true)}
               {this.render_history()}
              </div>
            </div>
          )
      }
  }
}

reactMixin(App.prototype, ReactFireMixin)

export default App;



// WEBPACK FOOTER //
// ./src/App.js